import { jsx as _jsx } from "react/jsx-runtime";
import { Banner } from '@yonderland/andes-react';
import { useSelector } from 'react-redux';
import { useBasketOverviewConfig } from '../../../../context/ComponentConfigContext';
import { getDynamicMessage } from '../../../../util/BasketOverviewMessagesUtil';
import { makeGetBasketMappedProductsState, makeGetBasketPricingState, makeGetBasketVouchersState, } from '../../../../redux/basket/selectors/BasketSelector';
export const DynamicMessage = () => {
    const { dynamicMessages } = useBasketOverviewConfig();
    const pricing = useSelector(makeGetBasketPricingState());
    const products = useSelector(makeGetBasketMappedProductsState());
    const vouchers = useSelector(makeGetBasketVouchersState());
    if (!dynamicMessages)
        return null;
    const dynamicMessage = getDynamicMessage(dynamicMessages, products, pricing, vouchers);
    if (!dynamicMessage)
        return null;
    return _jsx(Banner, { status: "informative", text: dynamicMessage });
};
